import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSection","FadeIn","HomeEyebrow","HomeLead"] */ "/vercel/path0/src/components/siteglue/home/section-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamPortrait"] */ "/vercel/path0/src/components/siteglue/team-siteglue/specialist-portrait.tsx");
